import React, { Component, useEffect, useState } from 'react';

import { get_persone, get_stage, post_new_iscrizione } from '../api'
import { useLogin } from '../reducers';
import { IscrizioneStageForm, LoadingCircle } from '../components';
import { get_allergia, get_domanda_iscrizione } from '../api/auto-apis';
import { Link, useLocation } from 'react-router-dom';
import { displayPersona } from '../globals';


const IscrizioneHome = () => {

  const login = useLogin();
  const [persone, setPersone] = useState([]);
  const [stages, setStages] = useState([]);
  const [iscrizioni, setIscrizioni] = useState([]);
  const [allergie, setAllergie] = useState([]);

  const location = useLocation();


  useEffect(() => {
    get_persone().then(setPersone)
    get_stage().then(setStages)
    get_domanda_iscrizione().then(setIscrizioni)
    get_allergia().then(setAllergie)
  }, [])

  if (!login.logged_in) {
    return (
      <div className="container">
        <h1 className="page-header">Iscrizione allo stage</h1>
        <p>Per iscriverti, devi innanzitutto fare il login.</p>
      </div>
    )
  }

  const match = location.pathname.match(new RegExp("^/iscrizione/([0-9]+)/$"))
  if (match) {
    const iscr = iscrizioni.find(isc => isc.id === parseInt(match[1]));
    if (!iscr) {
      return <LoadingCircle />
    }
    return (
      <div className="container">
        <h1 className="page-header">Iscrizione allo stage</h1>
        <h2>Esamina iscrizione</h2>
        <IscrizioneStageForm
          key={iscr.id} stages={stages} persone={persone} allergie={allergie}
          old={iscr}
        />
      </div>
    )
  }

  return (
    <div className="container">
      <h1 className="page-header">Iscrizione allo stage</h1>
      <h2>Esamina le iscrizioni</h2>
      <ul>
        {iscrizioni.map(iscr => {
          const persona = persone.find(p => p.id === iscr.persona);
          const stage = stages.find(st => st.id === iscr.stage);
          const nome = !!persona ? displayPersona(persona) : "";
          return <li key={iscr.id}><Link to={`/iscrizione/${iscr.id}/`}>{stage?.titolo} - {nome}</Link></li>
        })}
      </ul>
      <br />
      <br />
      <h2>Nuova iscrizione</h2>
      <IscrizioneStageForm
        stages={stages} persone={persone} allergie={allergie}
      />
    </div>
  )
}

export default IscrizioneHome;
